import { DOM, isBrowser } from '@app/utils';
import { endsWith } from 'lodash';
import ironLegacyClient from '@app/data/ironLegacyClient';
import { select, put, apply, call } from 'redux-saga/effects';
import { history } from '@app/router';
import { getCustomerId } from '@app/redux/customer/selectors';
import { getPreviousUrlCode, getTheCountries } from './selectors';
import {
  createLocalizedUrlPieces,
  createPathname,
  handleCustomPathnames,
} from './transformers';
import {
  setPreviousUrl,
  setSavedLanguage,
  getCountriesSuccess,
  getCountriesError,
} from './actions';

export const onSetShowLocalizationSettings = ({
  payload: { showLocalizationSettings },
}) =>
  showLocalizationSettings
    ? document.body.classList.add('noscroll')
    : document.body.classList.remove('noscroll');

const createLanguageLocaleString = (languageUrl) => {
  const [language, locale] = languageUrl.split('-');
  return `${language}-${locale.toUpperCase()}`;
};

// eslint-disable-next-line func-names
export const updateCustomer = function* ({ language, currency }) {
  const customerFields = {
    language: createLanguageLocaleString(language),
  };

  if (currency) {
    customerFields['defaultCurrency'] = currency;
  }

  const customer = {
    Customer: customerFields,
  };

  const customerId = yield select(getCustomerId);
  if (customerId) {
    try {
      yield apply(ironLegacyClient, ironLegacyClient.updateCustomer, [
        customerId,
        customer,
      ]);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  }
};

// eslint-disable-next-line func-names
export const onSetLanguage = function* ({
  payload: { code, urlPrefix, url, currency },
  skipEffect,
}) {
  if (skipEffect) {
    return;
  }

  DOM.forceSetCookie('language_code', code);
  DOM.forceSetCookie('stockx_selected_locale', code);

  if (currency) {
    DOM.forceSetCookie('stockx_selected_currency', currency);
  }

  const previousUrlCode = yield select(getPreviousUrlCode);
  const previousLocationState = history.location.state;
  const urlPieces = createLocalizedUrlPieces(previousUrlCode)(
    window.location.pathname,
  );

  const localizedPathname = createPathname(urlPieces);
  let redirectPathname = handleCustomPathnames(
    `${urlPrefix}${localizedPathname.substring(1)}`,
  );

  if (endsWith(redirectPathname, '/')) {
    redirectPathname = redirectPathname.slice(0, -1);
  }

  const { search, hash } = window.location;
  history.push(`${redirectPathname}${search}${hash}`, previousLocationState);

  yield put(setPreviousUrl(url));
  yield put(setSavedLanguage(true));

  yield call(updateCustomer, { language: url, currency });

  if (isBrowser) {
    window.location.reload();
  }
};

export function* onSetLocalizationSettings({ payload }) {
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  yield call(onSetLanguage, { payload });
}

// eslint-disable-next-line func-names
export const onGetCountries = function* () {
  const countries = yield select(getTheCountries);

  // Only load countries if we do not already have countries
  if (countries.length !== 0) {
    return;
  }

  try {
    const res = yield apply(
      ironLegacyClient,
      ironLegacyClient.getAllCountries,
      [],
    );

    yield put(getCountriesSuccess(res.body));
  } catch (e) {
    yield put(getCountriesError(e));
  }
};

// eslint-disable-next-line func-names
export const onSetSelectedRegion = ({ payload: { selectedRegion } }) => {
  DOM.forceSetCookie('stockx_selected_region', selectedRegion);
};
